import React, { useEffect, useState, useRef } from "react"
import { MDBDataTable } from "mdbreact"
import {
    Row,
    Col,
    Card,
    CardBody,
    CardTitle,
    Dropdown,
    DropdownMenu,
    DropdownItem,
    DropdownToggle,
    Button,
    Modal,
    FormGroup,
    Form,
} from "reactstrap"
import { connect } from "react-redux"
import { setBreadcrumbItems } from "../../store/actions"
import { Link } from "react-router-dom"
import Breadcrumb from "../../components/Common/Breadcrumb"
// Import images
import substrateImg from "../../assets/images/SubstrateImg.png"
import fruitingImg from "../../assets/images/fruiting1.png"

import "../Batch/datatables.scss"
import { useFormik } from "formik"
import * as Yup from "yup"
import axios from "axios"
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const DatatableTables = props => {
    document.title = "Harvest Output | My Urban Farms"
    const adminKey = sessionStorage.getItem("pk_admin_key");
    const farmKey = sessionStorage.getItem("pk_farm_key");


    const breadcrumbItems = [
        // { title: "Batch Details", link: "#" },
    ]

    const [output, setOutput] = useState([])



    useEffect(() => {
        props.setBreadcrumbItems("Output", breadcrumbItems)
        fetchReportsByBatch();
    }, [])



    const fetchReportsByBatch = async () => {
        try {
            const res = await axios.post(
                `${process.env.REACT_APP_API_BASE_URL}/getAllOutput/harvest/`,
                { farmKey: farmKey}
            );

            const list = res.data.message?.data || [];

            const tableRows = list.map((item, index) => ({
                sno: index + 1,
                batch_num: item.batch_num,
                bag_num: item.bag_num,
                harvest_date: item.harvest_date,
                harvest_count: item.harvest_count,
            }));

            setOutput(tableRows);

        } catch (error) {
            console.error(error);
            toast.error("Failed to fetch");
        }
    };


    const data = {
        columns: [
            { label: "S.No", field: "sno", sort: "asc", width: 50 },
            { label: "Batch Number", field: "batch_num", sort: "asc" },
            { label: "Bag Number", field: "bag_num", sort: "asc" },
            { label: "Harvest Date ", field: "harvest_date", sort: "asc" },
            { label: "Harvest Count (In grams)", field: "harvest_count", sort: "asc" },
            
        ],
        rows: []
    };

    return (
        <React.Fragment>
            <div className="d-flex align-items-center justify-content-between mb-3">
                <Breadcrumb />
               
            </div>
            <Row>
                <Col className="col-12">
                    <Card>
                        <CardBody>
                            <MDBDataTable
                                responsive
                                striped
                                bordered
                                data={{ ...data, rows: output }}
                                noBottomColumns
                            />
                        </CardBody>
                    </Card>
                </Col>
            </Row>


        </React.Fragment>
    )
}

export default connect(null, { setBreadcrumbItems })(DatatableTables)
